import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  List,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import { useClientContext } from "../context/ClientContext";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useLoading } from "../context/LoadingContext";
import CustomChatbotAgentic from "../components/CustomChatbotAgentic";
import { useCenterPanelContext } from "../context/CenterPanelContext";

const interactionData = [
  {
    id: "cro",
    accordianTitle: "Prepare for upcoming Client Meeting",
    accordianData: [
      {
        id: "conversation-strategy",
        title: "Conversation Strategy",
        description:
          "Analyze Client’s Interactions with the Bank and recommend discussion points for next meetings",
        parent: true,
        subList: [
          {
            id: "previous-interactions",
            title: "Previous Interactions Summary",
            description: "Analyze previous client engagements to provide summary of discussion points and action items",
          },
          {
            id: "conversation-guidance",
            title: "Conversation Guidance",
            description:
              "Generate recommendation of tailored conversation points for upcoming client meetings​",
          },
        ],
      },
      {
        id: "cro-overview",
        title: "Client Relationship Overview",
        description:
          "​Generate an overview of Client’s Relationship with the Bank.",
        subList: [
          {
            id: "product-services-holdings",
            title: "Product & Services Holdings",
            description:
              "Generate summary of Product holdings & Relationship Revenue",
          },
          {
            id: "client-service-history",
            title: "Client Service History",
            description:
              "Generate a summary of service requests and overdue compliances​",
          },
        ],
      },
      {
        id: "company-research",
        title: "Company Research",
        description:
          "Generate a Summary of Company’s focus areas, EWS & Opportunities and latest Company news",
        subList: [
          {
            id: "strategic-vision",
            title: "Strategic Vision",
            description:
              "Generate summary of company’s short-term, long-term focus areas and EWS/Opportunities",
          },
          {
            id: "news-tracking",
            title: "News Tracking",
            description:
              "Generate an overview of recent development pertaining to the Company​",
          },
        ],
      },
      {
        id: "strategic-advisory",
        title: "Strategic Advisory",
        description:
          "Generate NBO recommendations and discussion points for client interactions",
        subList: [],
      },
    ],
  },
  {
    id: "optimal-pricing-strategy",
    accordianTitle: "Analyze optimal Pricing Strategy",
    accordianData: [],
  },
  {
    id: "generate-review-credit-memo",
    accordianTitle: "Generate & Review Credit Memo",
    accordianData: [],
  },
];

function CorporateAIRM() {
  const navigate = useNavigate();
  const { clientName, setClientName, clientGroup, setClientGroup } =
    useClientContext();
  const { showLoading, hideLoading } = useLoading();
  const { data, setData, marketOverviewData, setMarketOverviewData,
    section2Data, setSection2Data,
    section3Data, setSection3Data,
    section4Data, setSection4Data,
  } =
    useCenterPanelContext();
  const [selectedItem, setSelectedItem] = React.useState({});
  const [expanded, setExpanded] = React.useState(interactionData[0].id);

  const handleClientChange = (event) => {
    setClientGroup(event.target.value);
  };

  const handleTitleClick = (id, title, description, parent = false) => {
    setSelectedItem({ id, title, description, parent });
  };

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  console.log("section3Data", section3Data);

  return (
    <div className="flex h-[90vh]">
      {/* Left Column - 25% */}
      <div className="w-1/4 p-2">
        <div className="shadow-lg rounded-md bg-white h-full overflow-y-auto p-4">
          {interactionData.map((section) => (
            <Accordion
              key={section.id}
              sx={{ marginBottom: "16px" }}
              expanded={expanded === section.id}
              onChange={handleAccordionChange(section.id)}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                className="shadow-md"
              >
                <div className="text-sm font-semibold p-1">
                  {section.accordianTitle}
                </div>
              </AccordionSummary>
              <AccordionDetails>
                {section.accordianData.map((data) => (
                  <div key={data.id}>
                    <div
                      className="border p-1 rounded-md cursor-pointer"
                      style={{
                        borderLeft: "4px solid #00555C",
                        borderTop: "1px solid #D3D3D3",
                        borderRight: "1px solid #D3D3D3",
                        borderBottom: "1px solid #D3D3D3",
                        backgroundColor:
                          selectedItem.id === data.id
                            ? "#E6F5F6"
                            : "transparent",
                      }}
                      onClick={() =>
                        handleTitleClick(
                          data.id,
                          data.title,
                          data.description,
                          data.parent
                        )
                      }
                    >
                      <div className="text-xs font-medium mb-1 text-main">
                        {data.title}
                      </div>
                      <div className="text-xs mb-1">{data.description}</div>
                    </div>

                    {data.subList && (
                      <List>
                        {data.subList.map((subItem) => (
                          <div
                            key={subItem.id}
                            className="ml-6 border mb-1 px-2 py-1 rounded-md cursor-pointer"
                            style={{
                              border: "1px solid #D3D3D3",
                              backgroundColor:
                                selectedItem.id === subItem.id
                                  ? "#F3E5F5"
                                  : "transparent",
                            }}
                            onClick={() =>
                              handleTitleClick(
                                subItem.id,
                                subItem.title,
                                subItem.description,
                                false
                              )
                            }
                          >
                            <div className="text-xs font-medium mb-1 text-main">
                              {subItem.title}
                            </div>
                            <div className="text-xs mb-1">
                              {subItem.description}
                            </div>
                          </div>
                        ))}
                      </List>
                    )}
                  </div>
                ))}
              </AccordionDetails>
            </Accordion>
          ))}
        </div>
      </div>

      {/* Center Column - 50% */}
      <div className="w-1/2 p-2 overflow-y-auto shadow-lg rounded-md">
        <div className="bg-white h-full">
          <div className="p-2 space-y-6 bg-gray-50 min-h-screen">
            {/* Client Interaction Summary */}
            {/* {data.clientInteractionSummary && (
              <section className="bg-white p-6 shadow rounded-lg">
                <h2 className="text-md font-bold mb-4">Client Interaction Summary</h2>
                <div className="bg-gray-50 p-3 rounded">
                  <div className="text-xs">{data.clientInteractionSummary}</div>
                </div>
              </section>
            )} */}

{/* first section */}
            {/* Meetings Section */}
            {data.meetings && data.meetings.length > 0 && (
              <section className="bg-white p-6 shadow rounded-lg">
                <h2 className="text-md font-bold">
                  Recap of Previous Client Interactions
                </h2>
                {data.meetings.map((meeting, index) => (
                  <div key={index} className="mt-6 border-b pb-4">
                    <h3 className="text-sm font-bold">{meeting.title}</h3>

                    {meeting.participants && (
                      <div className="text-xs mt-2">
                        <h4 className="mt-4 font-bold text-xs">Participants</h4>
                        <ul className="list-disc pl-6">
                          <li>
                            <strong>Bank:</strong>{" "}
                            {meeting.participants.bank?.join(", ")}
                          </li>
                          <li>
                            <strong>Client:</strong>{" "}
                            {meeting.participants.client?.join(", ")}
                          </li>
                        </ul>
                      </div>
                    )}

                    {meeting.discussionTopics && (
                      <>
                        <h4 className="mt-4 font-bold text-xs">
                          Discussion Topics
                        </h4>
                        <ul className="list-disc pl-6">
                          {meeting.discussionTopics.map((topic, idx) => (
                            <li key={idx} className="text-xs">
                              {topic}
                            </li>
                          ))}
                        </ul>
                      </>
                    )}

                    {meeting.actionItems && (
                      <>
                        <h4 className="mt-4 font-bold text-xs">Action Items</h4>
                        <ul className="list-disc pl-6">
                          {meeting.actionItems.map((item, idx) => (
                            <li key={idx} className="text-xs">
                              <strong>{item.title}</strong>
                              <span className="text-xs block text-gray-600">
                                Assigned to: {item.owner} | Due Date:{" "}
                                {item.dueDate}
                              </span>
                            </li>
                          ))}
                        </ul>
                      </>
                    )}
                  </div>
                ))}
              </section>
            )}

            {data.title && (
              <section className="bg-white p-6 shadow rounded-lg space-y-6">
                <h2 className="text-md font-bold">{data.title}</h2>

                {data.discussionTopics && (
                  <div className="space-y-4">
                    {data.discussionTopics.map((topic, index) => (
                      <div key={index} className="bg-gray-50 rounded-lg">
                        <h3 className="text-xs font-bold">{topic.topic}</h3>
                        <ul className="list-disc pl-6">
                          {topic.points.map((point, idx) => (
                            <li key={idx} className="text-xs text-gray-600">
                              {point}
                            </li>
                          ))}
                        </ul>
                      </div>
                    ))}
                  </div>
                )}
              </section>
            )}
{/* second section */}
            {/* Products and Services Section */}
            {section2Data.productsAndServices && (
              <section className="bg-white p-6 shadow rounded-lg space-y-6">
                 <h2 className="text-md font-bold">
                  Products & Services Holdings 
                </h2>
                <h2 className="text-sm font-bold">
                  Products Holdings Overview
                </h2>

                {/* Loan Accounts Overview */}
                <div>
                  <h3 className="text-sm font-bold mb-3">
                    Loan Accounts Overview
                  </h3>
                  <div className="grid grid-cols-3 gap-4">
                    {Object.entries(
                      section2Data.productsAndServices.loanAccountsOverview
                    ).map(([key, value]) => (
                      <div
                        key={key}
                        className="bg-gray-50 p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow"
                      >
                        <div className="text-xs text-gray-600 mb-1">
                          {key.replace(/([A-Z])/g, " $1").trim()}
                        </div>
                        <div className="text-lg font-semibold text-main">
                          {value}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Product Breakdown */}
                <div>
                  <h3 className="text-sm font-bold mb-3">Product Breakdown</h3>
                  <div className="space-y-3">
                    {section2Data.productsAndServices.productBreakdown.map(
                      (product, index) => (
                        <div
                          key={index}
                          className="bg-gray-50 p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow"
                        >
                          <div className="text-sm font-semibold mb-2 text-main">
                            {product.productName}
                          </div>
                          <div className="grid grid-cols-2 gap-x-8 gap-y-2">
                            <div className="flex justify-between">
                              <span className="text-xs text-gray-600">
                                Type:
                              </span>
                              <span className="text-xs font-semibold">
                                {product.productType}
                              </span>
                            </div>
                            <div className="flex justify-between">
                              <span className="text-xs text-gray-600">
                                Credit Limit:
                              </span>
                              <span className="text-xs font-semibold">
                                {product.creditLimit}
                              </span>
                            </div>
                            <div className="flex justify-between">
                              <span className="text-xs text-gray-600">
                                Outstanding:
                              </span>
                              <span className="text-xs font-semibold">
                                {product.creditOutstanding}
                              </span>
                            </div>
                            <div className="flex justify-between">
                              <span className="text-xs text-gray-600">
                                Utilization:
                              </span>
                              <span className="text-xs font-semibold">
                                {product.utilization}
                              </span>
                            </div>
                          </div>
                        </div>
                      )
                    )}
                  </div>
                </div>

                {/* Liability Accounts Overview */}
                <div>
                  <h3 className="text-sm font-bold mb-3">
                    Liability Accounts Overview
                  </h3>
                  <div className="bg-gray-50 p-4 rounded-lg shadow-sm mb-3">
                    <div className="text-sm font-semibold">
                      Total Liabilities:
                      <span className="text-main ml-2">
                        {
                          section2Data.productsAndServices.liabilityAccountsOverview
                            .totalLiabilities
                        }
                      </span>
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-3">
                    {section2Data.productsAndServices.liabilityAccountsOverview.productBreakdown.map(
                      (product, index) => (
                        <div
                          key={index}
                          className="bg-gray-50 p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow"
                        >
                          <div className="text-xs text-gray-600 mb-1">
                            {product.productName}
                          </div>
                          <div className="text-sm font-semibold text-main">
                            {product.accountBalance}
                          </div>
                        </div>
                      )
                    )}
                  </div>
                </div>
              </section>
            )}

            {/* Relationship Revenue Section */}
            {section2Data.relationshipRevenue && (
              <section className="bg-white p-6 shadow rounded-lg">
                <h2 className="text-md font-bold">Relationship Revenue</h2>
                <div className="bg-gray-50 py-3 rounded">
                  <div className="text-xs font-bold">Total Revenue FY25</div>
                  <div className="text-lg font-bold text-main">
                    {section2Data.relationshipRevenue.totalRevenueFY25}
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div className="ml-1">
                    <h3 className="text-xs font-bold">Net Interest Income</h3>
                    <div className="space-y-2">
                      <div className="bg-gray-50 py-2 rounded">
                        <div className="text-xs">
                          Target:{" "}
                          {
                            section2Data.relationshipRevenue.revenueBreakdown
                              .netInterestIncomeTarget
                          }
                        </div>
                        <div className="text-xs">
                          Actual:{" "}
                          {
                            section2Data.relationshipRevenue.revenueBreakdown
                              .netInterestIncomeActual
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <h3 className="text-xs font-bold">Fee Commission Income</h3>
                    <div className="space-y-2">
                      <div className="bg-gray-50 py-2 rounded">
                        <div className="text-xs">
                          Target:{" "}
                          {
                            section2Data.relationshipRevenue.revenueBreakdown
                              .feeCommissionIncomeTarget
                          }
                        </div>
                        <div className="text-xs">
                          Actual:{" "}
                          {
                            section2Data.relationshipRevenue.revenueBreakdown
                              .feeCommissionIncomeActual
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            )}

            {/* Service History Section */}
            {section2Data.serviceHistory && (
              <section className="bg-white p-6 shadow rounded-lg">
                <h2 className="text-md font-bold">Service History of the Client</h2>
                <div className="grid grid-cols-3 gap-4">
                  <div className="bg-gray-50 py-3 rounded">
                    <div className="text-xs text-gray-600 font-bold">
                      Total Requests
                    </div>
                    <div className="text-lg font-bold text-main">
                      {section2Data.serviceHistory.totalRequests}
                    </div>
                  </div>
                  <div className="bg-gray-50 p-3 rounded">
                    <div className="text-xs text-gray-600 font-bold">
                      Open Requests
                    </div>
                    <div className="text-lg font-bold text-main">
                      {section2Data.serviceHistory.totalOpenRequests}
                    </div>
                  </div>
                  <div className="bg-gray-50 p-3 rounded">
                    <div className="text-xs text-gray-600 font-bold">
                      Resolved Requests
                    </div>
                    <div className="text-lg font-bold text-main">
                      {section2Data.serviceHistory.totalResolvedRequests}
                    </div>
                  </div>
                </div>

                <div className="mb-1">
                  <h3 className="text-xs font-bold mb-1">
                    Most Frequent Requests
                  </h3>
                  <ul className="list-disc pl-6">
                    {section2Data.serviceHistory.mostFrequentRequests.map(
                      (request, index) => (
                        <li key={index} className="text-xs">
                          {request}
                        </li>
                      )
                    )}
                  </ul>
                </div>

                <div className="bg-gray-50 p-1 rounded mb-1">
                  <div className="text-xs">
                    {section2Data.serviceHistory.resolutionEfficiency}
                  </div>
                </div>

                <div className="bg-gray-50 p-1 rounded">
                  <div className="text-xs font-bold">Pending Requests:</div>
                  <div className="text-xs">
                    {section2Data.serviceHistory.pendingRequests}
                  </div>
                </div>
              </section>
            )}

            {/* Recent Service Requests Section */}
            {section2Data.recentServiceRequests && (
              <section className="bg-white p-6 shadow rounded-lg">
                <h2 className="text-md font-bold">Recent Service Requests & Resolutions
                </h2>
                <div className="space-y-4">
                  {section2Data.recentServiceRequests.map((request, index) => (
                    <div
                      key={index}
                      className="bg-gray-50 p-3 rounded"
                      style={{ border: "1px solid #D3D3D3" }}
                    >
                      <div className="flex justify-between mb-2">
                        <span className="text-xs font-bold">
                          Request Date: {request.date}
                        </span>
                        <span
                          className="text-xs px-2 py-1 rounded"
                          style={{
                            backgroundColor:
                              request.requestStatus === "Resolved"
                                ? "#dcfce7"
                                : "#fef9c3",
                            color:
                              request.requestStatus === "Resolved"
                                ? "#166534"
                                : "#854d0e",
                          }}
                        >
                          {request.requestStatus}
                        </span>
                      </div>
                      <div className="text-xs font-bold">
                        {request.serviceType}
                      </div>
                      <div className="text-xs text-gray-600">
                        Product: {request.product}
                      </div>
                      <div className="text-xs text-gray-600">
                        Resolution Time: {request.resolutionTime}
                      </div>
                    </div>
                  ))}
                </div>
              </section>
            )}

            {/* Overdue Compliances and Payments Section */}
            {section2Data.overdueCompliancesPayments && (
              <section className="bg-white p-6 shadow rounded-lg">
                <h2 className="text-md font-bold mb-1">
                  Overdue Compliances and Payments
                </h2>
                <div className="bg-red-50 py-1 rounded mb-1">
                  <div className="text-xs font-bold">
                    Total Overdue Covenants:{" "}
                    {section2Data.overdueCompliancesPayments.totalOverdueCovenants}
                  </div>
                </div>

                <div className="mb-1">
                  <h3 className="text-xs font-bold mb-1">
                    Regulatory Covenants
                  </h3>
                  <ul className="list-disc pl-6">
                    {section2Data.overdueCompliancesPayments.regulatoryCovenants.map(
                      (covenant, index) => (
                        <li key={index} className="text-xs text-red-600">
                          {covenant}
                        </li>
                      )
                    )}
                  </ul>
                </div>

                <div className="bg-red-50 p-1 rounded">
                  <div className="text-xs font-bold">
                    Overdue Payments:{" "}
                    <span style={{ color: "#6c3483" }}>
                      {section2Data.overdueCompliancesPayments.overduePayments}
                    </span>
                  </div>
                  <div className="text-xs text-red-600 mt-1">
                    {section2Data.overdueCompliancesPayments.termLoanOverdue}
                  </div>
                </div>
              </section>
            )}

            {/* Summary Section */}
            {section2Data.summary && (
              <section className="bg-white p-6 shadow rounded-lg">
                <h2 className="text-md font-bold mb-1">
                  Summary
                </h2>
                <div className="space-y-1">
                  <div className="text-xs my-4">
                    <div className="mb-2 font-bold">
                      Recap of Client Interaction Summary:
                    </div>
                    <div className="text-xs">
                      {section2Data.summary.clientInteractionSummary}
                    </div>
                  </div>
                  <div className="text-xs mt-4">
                    <div className="mb-2 font-bold">
                      Products & Services Holdings Summary:
                    </div>
                    <div className="text-xs">
                      Pertamina maintains a diverse banking portfolio, including
                      loans and deposits.
                    </div>
                  </div>
                  <div className="bg-gray-50 py-1 rounded">
                    <div className="text-xs flex gap-2">
                      <span className="font-bold">Loan Exposure:</span>{" "}
                      <span className="text-main">
                        {section2Data.summary.loanExposure}
                      </span>
                    </div>
                    <div className="text-xs flex gap-2">
                      <span className="font-bold">Term Loan Utilization:</span>{" "}
                      <span className="text-main">
                        {section2Data.summary.termLoanUtilization}
                      </span>
                    </div>
                    <div className="text-xs flex gap-2">
                      <span className="font-bold">
                        Working Capital Utilization:
                      </span>{" "}
                      <span className="text-main">
                        {section2Data.summary.workingCapitalUtilization}
                      </span>
                    </div>
                    <div className="text-xs flex gap-2">
                      <span className="font-bold">Total Liabilities:</span>{" "}
                      <span className="text-main">
                        {section2Data.summary.totalLiabilities}
                      </span>
                    </div>
                    <div className="text-xs flex gap-2">
                      <span className="font-bold">Total Revenue FY25:</span>{" "}
                      <span className="text-main">
                        {section2Data.summary.totalRevenueFY25}
                      </span>
                    </div>
                    <div className="text-xs mt-4">
                      <div className="mb-2 font-bold">
                        Service History Summary:
                      </div>
                      <div className="text-xs">
                        {section2Data.summary.serviceHistorySummary}
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            )}
{/* third section  */}
            {/* Strategic Vision Section */}
            {section3Data?.strategicVision && (
              <section className="bg-white p-6 shadow rounded-lg">
                <h2 className="text-md font-bold mb-2">{section3Data.strategicVision.title}</h2>
                <div className="space-y-4">
                  <div className="text-sm font-bold mb-2">{section3Data.strategicVision.section}</div>
                  {section3Data.strategicVision.section_data.map((item, index) => (
                    <div key={index} className="bg-gray-50 py-1 rounded">
                      <div className="text-xs font-bold mb-2">{item.title}</div>
                      <div className="text-xs">{item.content}</div>
                    </div>
                  ))}
                </div>
              </section>
            )}

            {/* Early Warning Signals Section */}
            {section3Data?.earlyWarnings && (
              <section className="bg-white p-6 shadow rounded-lg">
                <h2 className="text-md font-bold mb-2">{section3Data.earlyWarnings.title}</h2>
                <div className="space-y-4">
                  <div className="text-sm font-bold mb-2">{section3Data.earlyWarnings.section}</div>
                  {section3Data.earlyWarnings.section_data.map((item, index) => (
                    <div key={index} className="bg-gray-50 py-1 rounded">
                      <div className="text-xs font-bold mb-2">{item.signal}</div>
                      <div className="text-xs">{item.description}</div>
                    </div>
                  ))}
                </div>
              </section>
            )}

            {/* News Tracking Section */}
            {section3Data?.newsTracking && (
              <section className="bg-white p-6 shadow rounded-lg">
                <h2 className="text-md font-bold mb-2">Latest News</h2>
                <div className="space-y-4">
                  {section3Data.newsTracking.map((news, index) => (
                    <div key={index} className="bg-gray-50 py-1 rounded">
                      <div className="flex justify-between mb-2">
                        <div className="text-xs font-bold">{news.title}</div>
                        <div className="text-xs text-gray-600 font-semibold">
                          {news.date}
                        </div>
                      </div>
                      <div className="text-xs">{news.content}</div>
                    </div>
                  ))}
                </div>
              </section>
            )}

            {/* Summary Section */}
            { section3Data?.summary && (
              <section className="bg-white p-6 shadow rounded-lg">
                <h2 className="text-md font-bold">Summary</h2>
                <div className="bg-gray-50 py-3 rounded">
                  <div className="mb-2 font-bold text-xs">
                    Strategic Vision Summary:
                  </div>
                  <div className="text-xs">{section3Data.summary.strategicVisionSummary}</div>
                </div>
                <div className="bg-gray-50 py-3 rounded">
                  <div className="mb-2 font-bold text-xs">News Tracking Summary:</div>
                  <div className="text-xs">{section3Data.summary.newsTrackingSummary}</div>
                </div>
              </section>
            )}
          </div>
        </div>
      </div>

      {/* Right Column - 25% */}
      <div className="w-1/4 py-2">
        <div className="shadow-lg rounded-md bg-white h-full">
          <CustomChatbotAgentic selectedItem={selectedItem} />
        </div>
      </div>
    </div>
  );
}

export default CorporateAIRM;
